/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input, OnDestroy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-preloader',
  template: '',
  styleUrls: ['preloader.component.scss'],
})
export class PreloaderComponent implements OnDestroy {

  @Input()
  set loading(loading: boolean) {
    document.body.classList.toggle('is-preloading', loading);
  }

  ngOnDestroy(): void {
    this.loading = false;
  }
}
